import styles from './CMSObjectForm.module.scss';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import { NOT_SAVED_ALERT } from './_constants';
import CMSMarkdownEditor from './CMSObjectForm/CMSMarkdownEditor';
import CMSRolesDropDown from './CMSObjectForm/CMSRolesDropDown';
import CMSApplicationSearch from './CMSObjectForm/CMSApplicationSearch/CMSApplicationSearch';
import IMSAppRoleDescriptions from './CMSObjectForm/IMSAppRoleDescription/IMSAppRoleDescriptions';

const CMSObjectForm = props => {
	return (
		<>
			<div className={styles.formContainer}>
				<div className={styles.formFields}>
					{!props.new ? (
						props.updateObject.Fields.map(field => {
							return (
								<CMSFormField
									key={`field-${field.ID}`}
									field={field}
									editable={props.editable}
									setWasEdited={props.setWasEdited}
									updateObject={props.updateObject}
									setUpdateObject={props.setUpdateObject}
									currentUser={props.currentUser}
									displayValidationError={
										props.displayValidationError
									}
									id={`field-${field.ID}`}
								/>
							);
						})
					) : props.selectedType &&
					  props.selectedType.FieldDefinitions ? (
						<div className={styles.formContainer}>
							{props.selectedType.FieldDefinitions.map(
								fieldDef => {
									return (
										<CMSCreateFormField
											key={`fieldDef-${fieldDef.ID}`}
											fieldDefinition={fieldDef}
											editable={true}
											setWasEdited={props.setWasEdited}
											updateObject={props.updateObject}
											setUpdateObject={
												props.setUpdateObject
											}
											currentUser={props.currentUser}
											displayValidationError={
												props.displayValidationError
											}
											id={`fieldDef-${fieldDef.ID}`}
										/>
									);
								}
							)}
						</div>
					) : null}
				</div>
			</div>
		</>
	);
};

export default CMSObjectForm;

//private-vvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvv

const CMSFormField = ({
	field,
	editable,
	setWasEdited,
	updateObject,
	currentUser,
	setUpdateObject,
	displayValidationError,
	id,
}) => {
	const copyFields = fieldsArr => {
		return fieldsArr.map(field => {
			return { ...field };
		});
	};

	const handleChange = e => {
		//NOTE FOR REVIEW: The destructuring here is a little unorthodox, however was required to correct bug that was updating original cms Object fields along with update object
		setWasEdited(true);

		//assign current user username as MaintUser
		let copyOfObj = { ...updateObject };
		copyOfObj.Fields = copyFields(updateObject.Fields);
		copyOfObj.MaintUser = currentUser.userProfile.NetworkID;

		copyOfObj.Fields.find(
			field => field.ID === parseInt(e.target.name)
		).PendingUpdateApprovalValue = e.target.value;
		setUpdateObject({ ...copyOfObj });

		//if an edit was made, alert user before navigating away from page before losing work
		function confirmExit() {
			let message = NOT_SAVED_ALERT;

			return message;
		}
		window.onbeforeunload = confirmExit;
	};

	const onMarkdownChange = (md, fieldID) => {
		setWasEdited(true);

		let copyOfObj = { ...updateObject };
		copyOfObj.Fields = copyFields(updateObject.Fields);
		copyOfObj.MaintUser = currentUser.userProfile.NetworkID;
		copyOfObj.Fields.find(
			copyField => copyField.ID === fieldID
		).PendingUpdateApprovalValue = md;
		setUpdateObject({ ...copyOfObj });
	};

	const renderInput = field => {
		//based on field.ContentType, render the appropriate input component
		//will need to add cases here as different input types are needed

		switch (field.FieldDefinition.ContentType) {
			case 'text':
				return (
					<TextareaAutosize
						name={field.ID}
						value={field.PendingUpdateApprovalValue}
						minRows={5}
						disabled={!editable}
						onChange={event => handleChange(event)}
						key={field.ID}
						className={styles.textArea}
						id={id}
					/>
				);
			case 'markdown':
				return (
					<CMSMarkdownEditor
						name={field.ID}
						value={field.PendingUpdateApprovalValue}
						disabled={!editable}
						onChange={onMarkdownChange}
						key={field.ID}
						className={styles.textArea}
						fieldID={field.ID}
						updateObject={updateObject}
						id={id}
					/>
				);
			case 'IMS-Roles':
				return (
					<CMSRolesDropDown
						name={field.ID}
						field={updateObject.Fields.find(
							f =>
								f.CMSFieldDefinitionID ===
								field.FieldDefinition.ID
						)}
						disabled={!editable}
						onChange={handleChange}
						key={field.FieldDefinition.ID}
						id={id}
					/>
				);
			case 'IMS-App':
				return (
					//uneditable in update mode, display app ID
					<div>
						<strong>ID: {field?.Value}</strong>
					</div>
				);
			case 'IMS-App-Roles':
				return (
					<IMSAppRoleDescriptions
						name={field.ID}
						field={updateObject.Fields.find(
							f =>
								f.CMSFieldDefinitionID ===
								field.FieldDefinition.ID
						)}
						disabled={!editable}
						onChange={handleChange}
						key={field.FieldDefinition.ID}
						id={id}
					/>
				);
			default:
				return null;
		}
	};

	return (
		<div className={styles.FieldContainer}>
			<div className={styles.FieldLabel}>
				{field.FieldDefinition.Label}
				<p>
					{displayValidationError(
						`field:${field.FieldDefinition.Label}`
					)}
				</p>
			</div>

			{renderInput(field)}
		</div>
	);
};

const CMSCreateFormField = ({
	fieldDefinition,
	editable,
	setWasEdited,
	updateObject,
	currentUser,
	setUpdateObject,
	displayValidationError,
	id,
}) => {
	const copyFields = fieldsArr => {
		return fieldsArr.map(field => {
			return { ...field };
		});
	};

	const handleChange = e => {
		setWasEdited(true);
		//assign current user username as MaintUser
		let copyOfObj = { ...updateObject };
		copyOfObj.Fields = copyFields(updateObject.Fields);
		copyOfObj.MaintUser = currentUser.userProfile.NetworkID;

		let editedField = copyOfObj.Fields.find(
			field => field.CMSFieldDefinitionID === parseInt(e.target.name)
		);
		if (editedField) {
			copyOfObj.Fields.find(
				field => field.CMSFieldDefinitionID === parseInt(e.target.name)
			).PendingUpdateApprovalValue = e.target.value;
		}

		setUpdateObject({ ...copyOfObj });

		//if an edit was made, alert user before navigating away from page before losing work
		function confirmExit() {
			let message = NOT_SAVED_ALERT;

			return message;
		}
		window.onbeforeunload = confirmExit;
	};

	const onMarkdownChange = md => {
		setWasEdited(true);

		let copyOfObj = { ...updateObject };
		copyOfObj.Fields = copyFields(updateObject.Fields);
		copyOfObj.MaintUser = currentUser.userProfile.NetworkID;

		copyOfObj.Fields.find(
			field => field.CMSFieldDefinitionID === fieldDefinition.ID
		).PendingUpdateApprovalValue = md;
		setUpdateObject({ ...copyOfObj });
	};

	const renderInput = () => {
		//based on field.ContentType, render the appropriate input component
		//will need to add cases here as different input types are needed
		switch (fieldDefinition.ContentType) {
			case 'text':
				return (
					<TextareaAutosize
						name={fieldDefinition.ID}
						value={fieldDefinition.PendingUpdateApprovalValue}
						minRows={5}
						disabled={!editable}
						onChange={event => handleChange(event)}
						key={fieldDefinition.ID}
						className={styles.textArea}
						id={id}
					/>
				);
			case 'markdown':
				return (
					<CMSMarkdownEditor
						name={fieldDefinition.ID}
						value={fieldDefinition.PendingUpdateApprovalValue}
						minRows={5}
						disabled={!editable}
						onChange={onMarkdownChange}
						key={fieldDefinition.ID}
						className={styles.textArea}
						id={id}
					/>
				);
			case 'IMS-Roles':
				if (updateObject.Fields) {
					return (
						<CMSRolesDropDown
							name={fieldDefinition.ID}
							field={updateObject.Fields.find(
								field =>
									field.CMSFieldDefinitionID ===
									fieldDefinition.ID
							)}
							disabled={!editable}
							onChange={handleChange}
							key={fieldDefinition.ID}
							id={id}
						/>
					);
				}
				break;
			case 'IMS-App':
				return (
					<CMSApplicationSearch
						name={fieldDefinition.ID}
						field={updateObject.Fields.find(
							f => f.CMSFieldDefinitionID === fieldDefinition.ID
						)}
						disabled={!editable}
						onChange={handleChange}
						key={fieldDefinition.ID}
						id={id}
					/>
				);
			case 'IMS-App-Roles':
				return (
					<IMSAppRoleDescriptions
						name={fieldDefinition.ID}
						field={updateObject.Fields.find(
							f => f.CMSFieldDefinitionID === fieldDefinition.ID
						)}
						disabled={!editable}
						onChange={handleChange}
						key={fieldDefinition.ID}
						id={id}
					/>
				);
			default:
				return null;
		}
	};

	return (
		<div className={styles.FieldContainer}>
			<div className={styles.FieldLabel}>
				{fieldDefinition.Label}
				<p>
					{displayValidationError(`field:${fieldDefinition.Label}`)}
				</p>
			</div>

			{renderInput()}
		</div>
	);
};
